import cx from "classnames";
import PropTypes from "prop-types";
import React from "react";
import escapeName from "../../utils/escape-form-name";

class PercentInput extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = { mounted: false };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  componentWillReceiveProps(next) {
    const { defaultValue } = next;
    if (defaultValue !== this.props.defaultValue) {
      const { input } = this.refs;
      input.defaultValue = defaultValue + "%";
      delete input.value;
      this.handleChange({ target: input });
    }
  }

  handleChange({ target }) {
    const value = parseInt(target.value, 10);

    if (isNaN(value)) {
      target.value = "";
    } else if (target.value !== value + "%") {
      const { selectionStart, selectionEnd } = target;
      target.value = value + "%";
      target.setSelectionRange(selectionStart, selectionEnd);
    }
  }

  render() {
    const { name, defaultValue } = this.props;
    const path = escapeName(name);
    const value =
      defaultValue === "" || defaultValue == null ? "" : defaultValue + "%";

    return (
      <div className="percent-input">
        <input
          ref="input"
          name={name}
          inputMode="numeric"
          pattern="-?\d+(\.\d+)?%"
          {...this.props}
          onChange={this.handleChange}
          className={cx("text-input", this.props.className)}
          defaultValue={value}
        />

        <input type="hidden" name="_percents[]" value={name} />
      </div>
    );
  }
}

PercentInput.contextTypes = { locals: PropTypes.object };

export default PercentInput;
